import { useState } from 'react';
import { Box } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import EditIcon from '@mui/icons-material/EditRounded';
import Button from '@components/Button';
import { Input } from '@components/Input';
import { Typography } from '@components/Typography';
import { useTranslation } from '@hooks';

const EditorHeader = ({ name, onNameChange, onBack, onSave, saving, readOnly }) => {
    const { t } = useTranslation();
    const [editing, setEditing] = useState(false);

    return (
        <Box
            sx={{
                height: 'var(--header-height)',
                flexShrink: 0,
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                px: 3,
                borderBottom: '1px solid var(--divider)',
                background: '#fff',
                '&& .MuiFormControl-root': { paddingBottom: 0 },
            }}
        >
            <ArrowBackIcon sx={{ cursor: 'pointer', color: 'var(--text-secondary)' }} onClick={onBack} />

            {editing && !readOnly ? (
                <Input
                    autoFocus
                    inputProps={{
                        value: name,
                        onChange: e => onNameChange(e.target.value),
                        onBlur: () => setEditing(false),
                        onKeyDown: e => e.key === 'Enter' && setEditing(false),
                    }}
                    placeholder={t('AutomationsPage.editor.namePlaceholder')}
                    sx={{ minWidth: 280 }}
                />
            ) : (
                <Box
                    sx={{ display: 'flex', alignItems: 'center', gap: 1, cursor: 'pointer' }}
                    onClick={() => setEditing(true)}
                >
                    <Typography variant="h6">{name || t('AutomationsPage.editor.namePlaceholder')}</Typography>
                    <EditIcon sx={{ fontSize: 16, color: 'var(--text-tertiary)' }} />
                </Box>
            )}

            <Box sx={{ flex: 1 }} />

            {!readOnly && (
                <Button variant="contained" disabled={saving} onClick={onSave}>
                    {t('AutomationsPage.editor.save')}
                </Button>
            )}
        </Box>
    );
};

export default EditorHeader;
